import InlineEdit from "../InlineEdit";
import EmailSVG from "../../svgs/email";
import PhoneSVG from "../../svgs/phone";
import MailSVG from "../../svgs/mail";
import TruckSVG from "../../svgs/truck";
import CommentSVG from "../../svgs/comment";
import { typeColorCondition } from "./constants";

const EditView = ({
  storedContact,
  handleStoredContact,
  handleClickContactType,
}) => {
  const handleEdit = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleStoredContact(name, value);
  };
  return (
    <>
      <div>
        <div className="row">
          <div className="col-7" id="detail-name">
            <InlineEdit
              text={storedContact.firstName}
              onSetText={(text) => handleStoredContact("firstName", text)}
            />{" "}
            <InlineEdit
              text={storedContact.lastName}
              onSetText={(text) => handleStoredContact("lastName", text)}
            />{" "}
          </div>
          <div className="col">
            <span
              className="contact-type ml-5"
              onClick={handleClickContactType}
            >
              <span
                className="hollow-circle"
                style={{
                  borderColor: typeColorCondition[storedContact.contactType],
                }}
              ></span>
              <p style={{ display: "inline", paddingLeft: "10px" }}>
                <span
                  style={{
                    color: typeColorCondition[storedContact.contactType],
                  }}
                >
                  {storedContact.contactType.toUpperCase()}
                </span>
              </p>
            </span>
          </div>
        </div>
        <div className="row detail-attribute">
          <div className="col-1">
            <EmailSVG width="1.75rem" fill="rgba(180, 180, 180, 1)" />
          </div>
          <div className="col">
            <InlineEdit
              text={storedContact.email}
              onSetText={(text) => handleStoredContact("email", text)}
              label="email"
            />
          </div>
        </div>
        <div className="row detail-attribute">
          <div className="col-1">
            <PhoneSVG width="1.75rem" fill="rgba(180, 180, 180, 1)" />
          </div>
          <div className="col">
            <div>
              <InlineEdit
                text={storedContact.phoneNumber}
                onSetText={(text) => handleStoredContact("phoneNumber", text)}
              />
            </div>
          </div>
        </div>
        <div className="row detail-attribute">
          <div className="col-1">
            <MailSVG width="1.75rem" fill="rgba(180, 180, 180, 1)" />
          </div>
          <div className="col detail-addresses">
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.mailingStreetAddress.length + 1}ch`,
                }}
                name="mailingStreetAddress"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.mailingStreetAddress}
              />{" "}
              <p>street</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.mailingCity.length + 1}ch`,
                }}
                name="mailingCity"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.mailingCity}
              />
              <p>city</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.mailingRegion.length + 1}ch`,
                }}
                name="mailingRegion"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.mailingRegion}
              />
              <p>state / region</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.mailingZipCode.length + 1}ch`,
                }}
                name="mailingZipCode"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.mailingZipCode}
              />
              <p>zipcode</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.mailingCountry.length + 1}ch`,
                }}
                name="mailingCountry"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.mailingCountry}
              />
              <p>country</p>
            </div>
          </div>
        </div>
        <div className="row detail-attribute">
          <div className="col-1">
            <TruckSVG width="1.75rem" fill="rgba(180, 180, 180, 1)" />
          </div>

          <div className="col detail-addresses">
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.deliveryStreetAddress.length + 1}ch`,
                }}
                name="deliveryStreetAddress"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.deliveryStreetAddress}
              />{" "}
              <p>street</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.deliveryCity.length + 1}ch`,
                }}
                name="deliveryCity"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.deliveryCity}
              />
              <p>city</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.deliveryRegion.length + 1}ch`,
                }}
                name="deliveryRegion"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.deliveryRegion}
              />
              <p>state / region</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.deliveryZipCode.length + 1}ch`,
                }}
                name="deliveryZipCode"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.deliveryZipCode}
              />
              <p>zipcode</p>
            </div>
            <div className="each">
              <input
                autoComplete="nope"
                style={{
                  width: `${storedContact.deliveryCountry.length + 1}ch`,
                }}
                name="deliveryCountry"
                onChange={(e) => handleEdit(e)}
                defaultValue={storedContact.deliveryCountry}
              />
              <p>country</p>
            </div>
          </div>
        </div>
        <div className="row detail-attribute">
          <div className="col-1">
            <CommentSVG width="1.75rem" fill="rgba(180, 180, 180, 1)" />
          </div>
          <div className="col">
            <p>"{storedContact.description}"</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditView;
